/** Every AppBar.tsx/ToolRail.tsx dropdown menu — passed to
 * `dialogs.toggleExclusive` so opening one always closes any sibling still
 * open, across BOTH components (they share the same `dialogs` instance,
 * owned by App.tsx). Split out of AppToolbar.tsx (UI redesign phase 3,
 * which split that single 491-line/47-prop component into an app bar and a
 * tool rail) so both sides list the exact same group, instead of two
 * literal arrays that could quietly drift apart. */
export const TOOLBAR_MENU_GROUP = [
  "projectMenu",
  "addElementMenu",
  "selectionToolsMenu",
  "toolsMenu",
  "projectDataMenu",
] as const;
